import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class CrmHolidayService {
  private readonly baseUrl = '/api/crm/holidays';

  constructor(
    private httpService: HttpService,
    private constantsService: ConstantsService
  ) {}

  getHolidays(): Observable<any> {
    const requestData = {
      API_URL: this.baseUrl,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
    };
    return this.httpService.sendRequest(requestData);
  }

  createHoliday(payload: any, userEmail: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}?userEmail=${encodeURIComponent(userEmail)}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_POST,
      BODY: payload
    };
    return this.httpService.sendRequest(requestData);
  }

  updateHoliday(id: number, payload: any, userEmail: string): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}/${id}?userEmail=${encodeURIComponent(userEmail)}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_PUT,
      BODY: payload
    };
    return this.httpService.sendRequest(requestData);
  }

  deleteHoliday(id: number): Observable<any> {
    const requestData = {
      API_URL: `${this.baseUrl}/${id}`,
      REQUEST_METHOD: this.constantsService.REQUEST_METHOD_DELETE
    };
    return this.httpService.sendRequest(requestData);
  }
}
